import { render, staticRenderFns } from "./WidgetDataTable.vue?vue&type=template&id=7d89c8e0&scoped=true&"
import script from "./WidgetDataTable.vue?vue&type=script&lang=js&"
export * from "./WidgetDataTable.vue?vue&type=script&lang=js&"
import style0 from "./WidgetDataTable.vue?vue&type=style&index=0&id=7d89c8e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d89c8e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d89c8e0')) {
      api.createRecord('7d89c8e0', component.options)
    } else {
      api.reload('7d89c8e0', component.options)
    }
    module.hot.accept("./WidgetDataTable.vue?vue&type=template&id=7d89c8e0&scoped=true&", function () {
      api.rerender('7d89c8e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stats/widgets/WidgetDataTable.vue"
export default component.exports